import React from 'react';

const MultiBuildings = (props: object) => {
  return (
    <svg
      width="392"
      height="267"
      viewBox="0 0 392 267"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.8089 211.637C23.8089 211.637 -2.60598 252.565 60.2764 257.532C123.159 262.498 140.027 256.288 150.762 255.048C161.498 253.809 192.733 230.834 245.643 259.395C281.474 278.739 319.466 256.296 337.102 242.627C354.737 228.959 365.473 214.063 357.037 211.579C348.602 209.096 23.8089 211.637 23.8089 211.637Z"
        fill="#F5F9FF"
      />
      <path
        d="M22.4143 213.984C22.4143 213.984 -15.1918 158.391 7.0175 136.83C29.4898 115.014 -0.104477 87.7075 9.82606 55.896C18.2285 28.9734 69.5176 -15.1867 116.567 5.22237C181.531 33.405 181.226 39.6044 221.199 32.6683C261.173 25.7322 307.53 -12.023 330.044 35.4831C343.387 63.6347 380.069 69.8109 389.032 96.0084C397.995 122.206 384.494 154.994 377.09 162.163C350.838 187.601 359.801 215.066 359.801 215.066L22.4143 213.984Z"
        fill="#F5F9FF"
      />
      <path
        d="M201.339 86.9419C207.236 86.9419 212.016 81.8202 212.016 75.5022C212.016 69.1842 207.236 64.0625 201.339 64.0625C195.442 64.0625 190.662 69.1842 190.662 75.5022C190.662 81.8202 195.442 86.9419 201.339 86.9419Z"
        fill="#CCE4FF"
        fillOpacity="0.31"
      />
      <path
        d="M213.54 83.8896C218.595 83.8896 222.692 80.4752 222.692 76.2632C222.692 72.0512 218.595 68.6367 213.54 68.6367C208.486 68.6367 204.389 72.0512 204.389 76.2632C204.389 80.4752 208.486 83.8896 213.54 83.8896Z"
        fill="#CCE4FF"
        fillOpacity="0.31"
      />
      <path
        d="M293.618 80.8405C299.093 80.8405 303.532 76.4017 303.532 70.9261C303.532 65.4505 299.093 61.0117 293.618 61.0117C288.142 61.0117 283.703 65.4505 283.703 70.9261C283.703 76.4017 288.142 80.8405 293.618 80.8405Z"
        fill="#CCE4FF"
        fillOpacity="0.31"
      />
      <path
        d="M282.179 79.3154C286.391 79.3154 289.806 75.9009 289.806 71.689C289.806 67.477 286.391 64.0625 282.179 64.0625C277.967 64.0625 274.553 67.477 274.553 71.689C274.553 75.9009 277.967 79.3154 282.179 79.3154Z"
        fill="#CCE4FF"
        fillOpacity="0.31"
      />
      <path
        d="M307.346 80.8408C311.137 80.8408 314.21 77.4263 314.21 73.2144C314.21 69.0024 311.137 65.5879 307.346 65.5879C303.555 65.5879 300.482 69.0024 300.482 73.2144C300.482 77.4263 303.555 80.8408 307.346 80.8408Z"
        fill="#CCE4FF"
        fillOpacity="0.31"
      />
      <path
        d="M45.7591 86.942C51.6558 86.942 56.4361 82.1617 56.4361 76.2649C56.4361 70.3682 51.6558 65.5879 45.7591 65.5879C39.8623 65.5879 35.082 70.3682 35.082 76.2649C35.082 82.1617 39.8623 86.942 45.7591 86.942Z"
        fill="white"
      />
      <path
        d="M35.0815 82.3643C39.2935 82.3643 42.708 79.2913 42.708 75.5005C42.708 71.7098 39.2935 68.6367 35.0815 68.6367C30.8696 68.6367 27.4551 71.7098 27.4551 75.5005C27.4551 79.2913 30.8696 82.3643 35.0815 82.3643Z"
        fill="white"
      />
      <path
        d="M49.3652 57.0801L49.7517 212.373H173.037L172.651 57.4666L49.3652 57.0801Z"
        fill="#E1EAFF"
      />
      <path
        d="M43.9551 42.7793L176.516 43.1658L176.902 57.4653H43.9551V42.7793Z"
        fill="#B7D4F5"
      />
      <path
        d="M176.516 86.0664H43.9551V90.3176H176.516V86.0664Z"
        fill="#B7D4F5"
      />
      <path
        d="M172.264 89.9297H49.752V94.1809H172.264V89.9297Z"
        fill="#B7D4F5"
      />
      <path
        d="M171.878 56.3066H49.3652V60.5579H171.878V56.3066Z"
        fill="#B7D4F5"
      />
      <path
        d="M177.287 212.055H44.7266V216.306H177.287V212.055Z"
        fill="#B7D4F5"
      />
      <path
        d="M61.7317 65.582L57.4805 70.2197V76.7898L61.3452 80.6545L160.669 81.041L164.534 77.5627V70.2197L159.896 65.582H61.7317Z"
        fill="#B7D4F5"
      />
      <path
        d="M49.3652 103.842H57.0947V108.866H49.7517L49.3652 103.842Z"
        fill="#B7D4F5"
      />
      <path
        d="M49.3652 154.084H54.0029V159.108H49.7517L49.3652 154.084Z"
        fill="#B7D4F5"
      />
      <path
        d="M103.469 146.74H91.1016V151.378H103.469V146.74Z"
        fill="#B7D4F5"
      />
      <path
        d="M96.1289 154.471H83.7617V159.108H96.1289V154.471Z"
        fill="#B7D4F5"
      />
      <path
        d="M90.1563 125.994H77.7891V130.632H90.1563V125.994Z"
        fill="#B7D4F5"
      />
      <path
        d="M118.543 154.857H106.176V159.495H118.543V154.857Z"
        fill="#B7D4F5"
      />
      <path
        d="M96.6406 99.2891H84.2734V103.927H96.6406V99.2891Z"
        fill="#B7D4F5"
      />
      <path
        d="M166.082 152.148H153.715V156.786H166.082V152.148Z"
        fill="#B7D4F5"
      />
      <path
        d="M168.012 95.3379H155.645V99.9756H168.012V95.3379Z"
        fill="#B7D4F5"
      />
      <path
        d="M164.768 167.605H142.326C141.593 167.605 141 168.199 141 168.931V211.946C141 212.678 141.593 213.271 142.326 213.271H164.768C165.5 213.271 166.094 212.678 166.094 211.946V168.931C166.094 168.199 165.5 167.605 164.768 167.605Z"
        fill="#B7D4F5"
      />
      <path
        d="M162.415 172.752H144.73C143.998 172.752 143.404 173.345 143.404 174.078V178.746C143.404 179.478 143.998 180.072 144.73 180.072H162.415C163.147 180.072 163.741 179.478 163.741 178.746V174.078C163.741 173.345 163.147 172.752 162.415 172.752Z"
        fill="white"
      />
      <path
        d="M56.5363 119.328H59.06L87.2417 119.301C87.2417 119.301 88.7876 110.798 82.604 105.774C76.4204 100.75 70.0165 100.75 65.3788 103.069C60.7411 105.388 56.3623 108.866 56.5363 119.328Z"
        fill="#B7D4F5"
      />
      <path
        d="M59.056 119.328L58.8435 139.931H85.0696V118.806L58.6348 118.381L59.056 119.328Z"
        fill="#B7D4F5"
      />
      <path
        d="M58.8448 139.93L57.1211 139.807V143.293H86.7676L86.6207 139.807L58.8448 139.93Z"
        fill="#B7D4F5"
      />
      <path d="M71.263 120.482H62.1074V128.911H71.263V120.482Z" fill="white" />
      <path d="M81.8767 120.383H73.127V128.812H81.8767V120.383Z" fill="white" />
      <path
        d="M81.9999 130.992H73.0801V139.421H81.9999V130.992Z"
        fill="white"
      />
      <path
        d="M71.3509 130.988H62.1953V139.417H71.3509V130.988Z"
        fill="white"
      />
      <path
        d="M60.2346 106.771L59.1602 119.385L64.4008 119.215L65.4674 103.049L62.1515 104.993L60.6365 106.345"
        fill="#B7D4F5"
      />
      <path
        d="M83.988 107.033L84.9735 119.388L80.1735 119.222L79.2344 103.523L82.1948 105.452L83.6209 106.619"
        fill="#B7D4F5"
      />
      <path
        d="M67.1466 106.523L66.4316 119.265L71.0036 119.343L72.0278 101.596L70.049 101.65L67.6606 102.098"
        fill="#B7D4F5"
      />
      <path
        d="M77.8909 106.472L78.5363 119.214L74.4243 119.291L73.5547 101.664L75.7112 102.116L77.5122 102.692"
        fill="#B7D4F5"
      />
      <path
        d="M95.6884 119.597H98.2121L126.394 119.57C126.394 119.57 127.94 111.068 121.756 106.044C115.573 101.02 109.169 101.02 104.531 103.338C99.8932 105.657 95.5183 109.147 95.6884 119.597Z"
        fill="#B7D4F5"
      />
      <path
        d="M98.2122 119.593L97.9997 140.2H124.222V119.072L97.7871 118.646L98.2122 119.593Z"
        fill="#B7D4F5"
      />
      <path
        d="M98.001 140.202L96.2773 140.074V143.564H125.92L125.777 140.074L98.001 140.202Z"
        fill="#B7D4F5"
      />
      <path
        d="M110.419 120.746H101.264V129.175H110.419V120.746Z"
        fill="white"
      />
      <path
        d="M121.029 120.648H112.279V129.077H121.029V120.648Z"
        fill="white"
      />
      <path
        d="M121.152 131.258H112.232V139.687H121.152V131.258Z"
        fill="white"
      />
      <path
        d="M110.507 131.256H101.352V139.685H110.507V131.256Z"
        fill="white"
      />
      <path
        d="M99.3869 107.036L98.3125 119.651L103.553 119.485L104.62 103.318L101.308 105.262L99.7888 106.615"
        fill="#B7D4F5"
      />
      <path
        d="M123.138 107.3L124.124 119.66L119.324 119.493L118.385 103.791L121.345 105.72L122.771 106.887"
        fill="#B7D4F5"
      />
      <path
        d="M106.299 106.791L105.584 119.533L110.156 119.61L111.18 101.863L109.201 101.917L106.813 102.37"
        fill="#B7D4F5"
      />
      <path
        d="M117.043 106.741L117.685 119.48L113.577 119.557L112.703 101.934L114.864 102.382L116.661 102.958"
        fill="#B7D4F5"
      />
      <path
        d="M134.308 119.597H136.831L165.013 119.57C165.013 119.57 166.559 111.068 160.375 106.044C154.192 101.02 147.788 101.02 143.15 103.338C138.513 105.657 134.134 109.147 134.308 119.597Z"
        fill="#B7D4F5"
      />
      <path
        d="M136.829 119.593L136.617 140.2H162.843V119.072L136.404 118.646L136.829 119.593Z"
        fill="#B7D4F5"
      />
      <path
        d="M136.618 140.202L134.895 140.074V143.564H164.541L164.394 140.074L136.618 140.202Z"
        fill="#B7D4F5"
      />
      <path
        d="M149.034 120.746H139.879V129.175H149.034V120.746Z"
        fill="white"
      />
      <path
        d="M159.646 120.648H150.896V129.077H159.646V120.648Z"
        fill="white"
      />
      <path
        d="M159.771 131.258H150.852V139.687H159.771V131.258Z"
        fill="white"
      />
      <path
        d="M149.122 131.256H139.967V139.685H149.122V131.256Z"
        fill="white"
      />
      <path
        d="M138.006 107.036L136.932 119.651L142.172 119.485L143.235 103.318L139.923 105.262L138.404 106.615"
        fill="#B7D4F5"
      />
      <path
        d="M161.759 107.3L162.745 119.66L157.941 119.493L157.006 103.791L159.966 105.72L161.392 106.887"
        fill="#B7D4F5"
      />
      <path
        d="M144.918 106.791L144.203 119.533L148.775 119.61L149.795 101.863L147.821 101.917L145.432 102.37"
        fill="#B7D4F5"
      />
      <path
        d="M155.659 106.741L156.304 119.48L152.192 119.557L151.322 101.934L153.479 102.382L155.276 102.958"
        fill="#B7D4F5"
      />
      <path
        d="M56.6216 178.263H63.3037L137.893 178.236C137.893 178.236 143.949 168.837 127.582 163.705C111.215 158.572 84.297 160.033 72.0342 162.402C59.7714 164.771 56.1656 167.593 56.6216 178.263Z"
        fill="#B7D4F5"
      />
      <path
        d="M57.6012 178.454L56.9481 212.128H137.679V177.604L56.2949 176.908L57.6012 178.454Z"
        fill="#B7D4F5"
      />
      <path d="M132.648 178.91H61.5176V196.058H132.648V178.91Z" fill="white" />
      <path d="M107.085 198.82H86.5977V207.249H107.085V198.82Z" fill="white" />
      <path d="M82.489 198.967H62.002V207.396H82.489V198.967Z" fill="white" />
      <path
        d="M131.973 198.967H111.486V207.396H131.973V198.967Z"
        fill="white"
      />
      <path
        d="M64.1757 165.066L62.7148 177.244L69.6753 177.086L70.912 162.33L66.8308 163.308L64.5738 164.235"
        fill="#B7D4F5"
      />
      <path
        d="M75.6632 165.186L74.4922 177.124L81.4758 177.035L82.7473 160.861L79.3386 161.263L76.2584 161.549"
        fill="#B7D4F5"
      />
      <path
        d="M127.662 164.975L128.81 177.152L123.337 176.994L122.367 162.238L125.575 163.216L127.349 164.144"
        fill="#B7D4F5"
      />
      <path
        d="M118.581 165.102L119.555 177.04L113.739 176.951L112.684 160.777L115.52 161.179L118.083 161.465"
        fill="#B7D4F5"
      />
      <path
        d="M107.901 165.006L108.875 176.944L103.059 176.859L101.977 160.303L104.732 160.438L107.356 160.573"
        fill="#B7D4F5"
      />
      <path
        d="M95.2547 165.454L96.2287 177.392L90.4122 177.307L89.3301 160.754L92.2286 160.654L94.9533 160.596"
        fill="#B7D4F5"
      />
      <path
        d="M182.613 137.92L182.246 215.285L312.979 215.636V137.201L182.613 137.92Z"
        fill="#E1EAFF"
      />
      <path
        d="M314.082 211.682H181.521V215.933H314.082V211.682Z"
        fill="#B7D4F5"
      />
      <path
        d="M320.367 137.85H175.385V142.974H320.367V137.85Z"
        fill="#B7D4F5"
      />
      <path
        d="M177.674 138.683C177.674 138.683 179.22 115.649 194.292 115.208C206.706 114.845 270.331 115.158 292.248 115.359C305.156 115.479 316.21 125.021 317.783 137.832C317.816 138.113 317.847 138.397 317.875 138.683H177.674Z"
        fill="#B7D4F5"
      />
      <path
        d="M305.006 172.729H312.735V177.753H305.392L305.006 172.729Z"
        fill="#B7D4F5"
      />
      <path
        d="M308.193 151.744H312.831V156.768H308.58L308.193 151.744Z"
        fill="#B7D4F5"
      />
      <path
        d="M200.633 189.252H188.266V193.89H200.633V189.252Z"
        fill="#B7D4F5"
      />
      <path
        d="M196.258 168.881H183.891V173.519H196.258V168.881Z"
        fill="#B7D4F5"
      />
      <path
        d="M203.941 152.381H191.574V157.019H203.941V152.381Z"
        fill="#B7D4F5"
      />
      <path
        d="M247.918 148.314H235.551V152.952H247.918V148.314Z"
        fill="#B7D4F5"
      />
      <path
        d="M310.316 163.74H297.949V168.378H310.316V163.74Z"
        fill="#B7D4F5"
      />
      <path
        d="M303.631 199.555H291.264V204.192H303.631V199.555Z"
        fill="#B7D4F5"
      />
      <path
        d="M274.268 144.609H261.9V149.247H274.268V144.609Z"
        fill="#B7D4F5"
      />
      <path
        d="M206.346 177.763H213.028L287.618 177.736C287.618 177.736 293.674 168.337 277.307 163.205C260.94 158.072 234.022 159.533 221.759 161.902C209.496 164.271 205.89 167.093 206.346 177.763Z"
        fill="#B7D4F5"
      />
      <path
        d="M207.326 177.954L206.673 211.628H287.403V177.104L206.02 176.408L207.326 177.954Z"
        fill="#B7D4F5"
      />
      <path d="M282.371 178.41H236.322V195.558H282.371V178.41Z" fill="white" />
      <path d="M256.809 198.32H236.322V206.749H256.809V198.32Z" fill="white" />
      <path
        d="M232.214 178.729H211.727V206.895H232.214V178.729Z"
        fill="white"
      />
      <path
        d="M281.704 198.467H261.217V206.896H281.704V198.467Z"
        fill="white"
      />
      <path
        d="M213.898 164.566L212.441 176.744L219.402 176.586L220.635 161.83L216.557 162.808L214.3 163.735"
        fill="#B7D4F5"
      />
      <path
        d="M225.386 164.686L224.219 176.624L231.202 176.535L232.47 160.361L229.065 160.763L225.985 161.049"
        fill="#B7D4F5"
      />
      <path
        d="M277.39 164.475L278.534 176.652L273.066 176.494L272.096 161.738L275.3 162.716L277.074 163.644"
        fill="#B7D4F5"
      />
      <path
        d="M268.31 164.602L269.28 176.54L263.463 176.451L262.408 160.277L265.245 160.679L267.811 160.965"
        fill="#B7D4F5"
      />
      <path
        d="M257.626 164.508L258.6 176.446L252.783 176.361L251.701 159.809L254.457 159.94L257.081 160.075"
        fill="#B7D4F5"
      />
      <path
        d="M244.983 164.956L245.953 176.89L240.137 176.805L239.055 160.252L241.953 160.152L244.678 160.098"
        fill="#B7D4F5"
      />
      <path
        d="M325.924 210.908H325.92C324.925 210.908 324.119 211.715 324.119 212.709V216.473C324.119 217.468 324.925 218.274 325.92 218.274H325.924C326.919 218.274 327.725 217.468 327.725 216.473V212.709C327.725 211.715 326.919 210.908 325.924 210.908Z"
        fill="white"
      />
      <path
        d="M337.52 210.908H337.516C336.521 210.908 335.715 211.715 335.715 212.709V216.473C335.715 217.468 336.521 218.274 337.516 218.274H337.52C338.514 218.274 339.321 217.468 339.321 216.473V212.709C339.321 211.715 338.514 210.908 337.52 210.908Z"
        fill="white"
      />
      <path
        d="M322.713 184.13C322.713 184.13 319.915 213.174 320.448 213.572C320.982 213.97 342.296 214.237 342.829 213.839C343.363 213.44 341.229 184.397 340.831 184.262C340.433 184.126 323.378 183.732 322.713 184.13Z"
        fill="#B7D4F5"
      />
      <path
        d="M337.964 191.459H326.242C325.837 191.459 325.508 191.787 325.508 192.191C325.508 192.596 325.837 192.924 326.242 192.924H337.964C338.369 192.924 338.698 192.596 338.698 192.191C338.698 191.787 338.369 191.459 337.964 191.459Z"
        fill="white"
      />
      <path
        d="M339.296 196.117H324.644C324.239 196.117 323.91 196.445 323.91 196.85C323.91 197.254 324.239 197.582 324.644 197.582H339.296C339.701 197.582 340.03 197.254 340.03 196.85C340.03 196.445 339.701 196.117 339.296 196.117Z"
        fill="white"
      />
    </svg>
  );
};

export default MultiBuildings;
